import { useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
import { cn } from "@/lib/utils";
import { twJoin, twMerge } from "tailwind-merge";

const HybridTooltip = ({
    content,
    children,
    className
  }: React.PropsWithChildren<{ content: string | React.ReactNode; className?: string }>) => {
    const [open, setOpen] = useState(false);
  
    return (
      <TooltipProvider>
        <Tooltip open={open}>
          <TooltipTrigger>
            <div
              className={cn('cursor-pointer', className)}
              onClick={() => setOpen(true)}
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
              onTouchStart={() => setOpen(true)}
              onKeyDown={(e) => {
                e.preventDefault();
                e.key === 'Enter' && setOpen(!open);
              }}
            >
              {children}
            </div>
          </TooltipTrigger>
          <TooltipContent className={twMerge('sm:max-w-md max-w-xs text-center', twJoin(!content ? 'hidden' : ''))}>
            <span className="inline-block">{content}</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  };
  
export default HybridTooltip;